// extracted by mini-css-extract-plugin
export default {"container":"ForOrganizationsHeroSection_container__Omc5Q","imgbg":"ForOrganizationsHeroSection_imgbg__7qzjo"};